import React from 'react'
import { Image, SimpleGrid, Button, Checkbox, Box, useBoolean, Text } from '@chakra-ui/react'
import { useHistory } from 'react-router'
import { Controller, useForm } from 'react-hook-form'
import Datetime from 'react-datetime'
import moment from 'moment'
import { Layout } from '../../../components'
import { ROUTES } from '../../../contants'
import { Input, Select, ControlledInput } from '../../../components/form'
import useMotorStore from '../../../state/Motor.store'
import { screens } from './types'
import { CHASSIS_NUMBER, MAKE, MODEL, PLATE_NUMBER } from '../../../utils/validations'

const Enter = () => {
  const [accepted, setAccepted] = useBoolean()
  const [setVehicleDetails, setScreen, loading, plate] = useMotorStore((state) => [
    state.setVehicleDetails,
    state.setScreen,
    state.loading,
    state.plate
  ])

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields, isValid },
    watch,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: { plate_number: plate, make: '', model: '', year: '', chasis_number: '' }
  })
  const onSubmit = async (data: any) => {
    try {
      await setVehicleDetails(data)
      setScreen(screens.MOTOR_DETAILS)
    } catch (error) {
      console.log(error)
    }
  }

  const inputProps = {
    placeholder: 'Year',
    autoComplete: 'off',
    readOnly: true
  }

  return (
    <Layout previous={() => setScreen(screens.ENTER_PLATE)} title="Vehicle Details">
      <Box id="my-form" flex={1} as="form" onSubmit={handleSubmit(onSubmit)}>
        <Image mx="auto" mb="3.2rem" h="207px" src="/images/loading.svg" />

        <SimpleGrid mt="1.6rem" columns={2} spacing="1.6rem">
          <Controller
            control={control}
            rules={MAKE}
            name="make"
            render={({ field }) => (
              <ControlledInput
                isValid={watch('make') && !errors.make && true}
                isError={errors.make && errors.make.message}
                label="Vehicle Brand"
                id="make"
                value={field.value}
                onChange={(e) => {
                  if (e.target.value.length > 15) {
                    e.preventDefault()
                    return
                  }
                  field.onChange(e)
                }}
              />
            )}
          />
          <Controller
            control={control}
            rules={MODEL}
            name="model"
            render={({ field }) => (
              <ControlledInput
                isValid={watch('model') && !errors.model && true}
                isError={errors.model && errors.model.message}
                label="Vehicle Model"
                id="model"
                value={field.value}
                onChange={(e) => {
                  if (e.target.value.length > 15) {
                    e.preventDefault()
                    return
                  }
                  field.onChange(e)
                }}
              />
            )}
          />

          {/* <Select
            isValid={watch('model') && touchedFields.model && !errors.model && true}
            isError={touchedFields.model && errors.model && errors.model.message}
            label="Model"
            id="model"
            value={watch('model')}
            formHook={register('model', {
              required: 'model is required'
            })}
            options={[
              { label: 'Camry', value: 'Camry' },
              { label: 'Corolla', value: 'Corolla' },
              { label: 'Elantra', value: 'Elantra' }
            ]}
          /> */}
        </SimpleGrid>
        <SimpleGrid columns={2} spacing="1.6rem">
          <Controller
            control={control}
            rules={PLATE_NUMBER}
            name="plate_number"
            render={({ field }) => (
              <ControlledInput
                isValid={watch('plate_number') && !errors.plate_number && true}
                isError={errors.plate_number && errors.plate_number.message}
                label="Vehicle Plate Number"
                id="plate_number"
                value={field.value}
                onChange={(e) => {
                  if (e.target.value.length > 15) {
                    e.preventDefault()
                    return
                  }
                  field.onChange(e)
                }}
              />
            )}
          />

          {/* <Input
            isValid={watch('year') && touchedFields.year && !errors.year && true}
            isError={touchedFields.year && errors.year && errors.year.message}
            label="Year"
            id="year"
            value={watch('year')}
            formHook={register('year', {
              required: 'Vehicle Plate Number required'
            })}
          /> */}

          <Box mb="2.4rem">
            <Controller
              control={control}
              name="year"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Datetime
                  onChange={(date) => onChange(moment(date).format('YYYY'))}
                  value={value}
                  closeOnSelect
                  timeFormat={false}
                  dateFormat="YYYY"
                  inputProps={inputProps}
                />
              )}
            />

            {errors.year && (
              <Text mt="0.7rem" fontSize="1rem" align="center" color="brand.red" d="flex">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.00065 13.6666C3.31865 13.6666 0.333984 10.6819 0.333984 6.99992C0.333984 3.31792 3.31865 0.333252 7.00065 0.333252C10.6827 0.333252 13.6673 3.31792 13.6673 6.99992C13.6673 10.6819 10.6827 13.6666 7.00065 13.6666ZM7.00065 12.3333C8.41514 12.3333 9.77169 11.7713 10.7719 10.7712C11.7721 9.77096 12.334 8.41441 12.334 6.99992C12.334 5.58543 11.7721 4.22888 10.7719 3.22868C9.77169 2.22849 8.41514 1.66659 7.00065 1.66659C5.58616 1.66659 4.22961 2.22849 3.22942 3.22868C2.22922 4.22888 1.66732 5.58543 1.66732 6.99992C1.66732 8.41441 2.22922 9.77096 3.22942 10.7712C4.22961 11.7713 5.58616 12.3333 7.00065 12.3333ZM6.33399 3.66658H7.66732V4.99992H6.33399V3.66658ZM6.33399 6.33325H7.66732V10.3333H6.33399V6.33325Z"
                    fill="#FD397A"
                  />
                </svg>
                <Text as="span" ml="0.5rem">
                  {errors.year && errors.year.message}
                </Text>
              </Text>
            )}
          </Box>
        </SimpleGrid>

        <Controller
          control={control}
          rules={CHASSIS_NUMBER}
          name="chasis_number"
          render={({ field }) => (
            <ControlledInput
              isValid={watch('chasis_number') && !errors.chasis_number && true}
              isError={errors.chasis_number && errors.chasis_number.message}
              label="Chassis Number"
              id="chasis_number"
              value={field.value}
              onChange={(e) => {
                if (e.target.value.length > 17) {
                  e.preventDefault()
                  return
                }
                field.onChange(e)
              }}
            />
          )}
        />
      </Box>
      <Checkbox onChange={setAccepted.toggle} mt="6rem" size="lg">
        I acknowledge that the information displayed above is accurate and up-to-date at this time
      </Checkbox>
      <Button
        isLoading={loading}
        disabled={!accepted || !isValid}
        form="my-form"
        type="submit"
        mt="2.4rem"
        variant="blue">
        Submit
      </Button>
    </Layout>
  )
}

export { Enter }
